import { VscSearch } from "react-icons/vsc";
export default function Header({
  setFastOrderingInfo,
  fastOrderingInfo,
  selectedItem,
  setSelectedItem,
}) {
  return (
    <div className="p-h">
      <div className="col-12 mainCover-fast">
        <img
          //   src={`http://sabadi.tatdemo.ir/${coverImg}`}
          src={fastOrderingInfo[0].headerInfo[0].headerBackground}
          alt="cover"
          className="col-12"
          id="cover-fast"
        />
      </div>
      <div className="box-parent-img d-flex justify-content-evenly">
        {fastOrderingInfo[0].search.map((value, index) => {
          return (
            <div
              className={`box-img-header ${
                selectedItem == index && "active-box"
              }`}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                setSelectedItem(index);
              }}
            >
              <div className="d-flex txt-search ">
                <div className="Circle-search">
                  <VscSearch></VscSearch>
                </div>
                <div className="txt-search-child">{value.titleSearch}</div>
              </div>
              <div className="d-flex justify-content-center img-search">
                <img
                  style={{ width: "100px" }}
                  src={value.imgSearch}
                  //alt={`${value.title}`}
                />
              </div>

              <br />
              {/* //<div className="title">{value.title} </div> */}
            </div>
          );
        })}
      </div>
    </div>
  );
}
